import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RoleDialogBody_RoleFragment = { __typename?: 'Role', id: number, name: string, userCount: number, roleLevelV2?: number | null, roleActionPermissions?: { __typename?: 'RoleActionPermissions', roleUserType: Types.UserType } | null };

export type RoleDialogBody_RolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RoleDialogBody_RolesQuery = { __typename?: 'Query', Roles: { __typename?: 'Roles', objects: Array<{ __typename?: 'Role', id: number, name: string, userCount: number, roleLevelV2?: number | null, roleActionPermissions?: { __typename?: 'RoleActionPermissions', roleUserType: Types.UserType } | null }> } };

export const RoleDialogBody_RoleFragmentDoc = gql`
    fragment RoleDialogBody_Role on Role {
  id
  name
  userCount
  roleLevelV2
  roleActionPermissions {
    roleUserType
  }
}
    `;
export const RoleDialogBody_RolesDocument = gql`
    query RoleDialogBody_Roles {
  Roles {
    objects {
      ...RoleDialogBody_Role
    }
  }
}
    ${RoleDialogBody_RoleFragmentDoc}`;

/**
 * __useRoleDialogBody_RolesQuery__
 *
 * To run a query within a React component, call `useRoleDialogBody_RolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDialogBody_RolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleDialogBody_RolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleDialogBody_RolesQuery(baseOptions?: Apollo.QueryHookOptions<RoleDialogBody_RolesQuery, RoleDialogBody_RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleDialogBody_RolesQuery, RoleDialogBody_RolesQueryVariables>(RoleDialogBody_RolesDocument, options);
      }
export function useRoleDialogBody_RolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleDialogBody_RolesQuery, RoleDialogBody_RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleDialogBody_RolesQuery, RoleDialogBody_RolesQueryVariables>(RoleDialogBody_RolesDocument, options);
        }
export type RoleDialogBody_RolesQueryHookResult = ReturnType<typeof useRoleDialogBody_RolesQuery>;
export type RoleDialogBody_RolesLazyQueryHookResult = ReturnType<typeof useRoleDialogBody_RolesLazyQuery>;
export type RoleDialogBody_RolesQueryResult = Apollo.QueryResult<RoleDialogBody_RolesQuery, RoleDialogBody_RolesQueryVariables>;